import { MxEventType } from '../models/workpacks';

export interface MxEventWithType {
  event_type?: MxEventType;
}

export function isResolutionEvent<T extends MxEventWithType>(
  event: T | null | undefined
): event is T {
  if (event == null) return false;
  return event.event_type === MxEventType.RESOLUTION;
}

export function getResolutionEvents<T extends MxEventWithType>(
  mxEvents: T[] | null | undefined
): T[] {
  if (mxEvents == null) return [];
  return mxEvents.filter(isResolutionEvent);
}

export function getLastResolutionEvent<T extends MxEventWithType>(
  mxEvents: T[] | null | undefined
): T | null {
  const resolutions = getResolutionEvents(mxEvents);
  return resolutions.length > 0 ? resolutions[resolutions.length - 1] : null;
}
